import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Role } from 'src/userRoles/userRoles';
import {
  Environment,
  EnvironmentService,
} from '../utility/environment.service';
import { AuthenticationService } from '../core/services/authentication.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  display: any;
  showFiller = false;
  isNavEnable: boolean = false;
  constructor(
    private environmentService: EnvironmentService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {this.getTermsStatus();}
  landingUrls: Map<Environment, string> = new Map([
    [Environment.DEV, 'https://admin-ibmdev.serviceplatformen.dk/'],
    [Environment.INTTEST, 'https://admin-ibminttest.serviceplatformen.dk'],
    [
      Environment.INTEGRATION,
      'https://admin-ibmintegration.serviceplatformen.dk',
    ],
    [
      Environment.PREEXTTEST,
      'https://admin-ibmpreexttest.serviceplatformen.dk',
    ],
    [Environment.PREPROD, 'https://admin-ibmpreprod.serviceplatformen.dk/'],
    [Environment.EXTTEST, 'https://admin-test.serviceplatformen.dk/'],
    [Environment.PROD, 'https://admin.serviceplatformen.dk/'],
  ]);

  public getLandingURL = (): string => {
    return this.landingUrls.get(this.environmentService.getEnvironment())??'';
  };

  navigateToSTSadmin() {
    if (this.getLandingURL()) {
      window.location.href = this.getLandingURL();
    }
  }

  navigateToRoute(location: string) {
    const currentUrl = this.router.url;
    if (currentUrl.endsWith(location)) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }

  isEnable(rvalue : string) {
    let rolevalue = this.authenticationService.getAppRole();
    if (rolevalue == null) {
      return false;
    }
    if(rvalue == 'routes' || rvalue == 'delegation') {
      if(rolevalue == "admin" || rolevalue == "supporter" || rolevalue == "authority" ||
        rolevalue == "authority_admin" ||  rolevalue=='provider' || rolevalue == 'provider_admin')
        {
          return true;
        }
    }
    else if(rvalue == 'administration' || rvalue == 'reports') {
      if(rolevalue == "admin" || rolevalue == "supporter") {
        return true;
      }
    }
    return false;
  }

  getTermsStatus()
  {
    this.authenticationService.getUserRolesForMenubar().subscribe((newRole)=>{
      if(newRole == "" || newRole == undefined){
        this.isNavEnable = false;
      }
      else{
        this.isNavEnable = true;
      }
    });
  }
}
